<template>
  <div class="authenticated">
    <div class="nav-bg container-fluid">
      <navigation></navigation>
    </div>
    <div class="container">
      <div class="application-content">
        <alert v-if="isError" type="danger"/>
        <alert v-if="isMessage" type="primary"/>
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Alert from '@/components/Alert'
  import Nav from '@/components/Nav'
  export default {
    name: 'Jury',
    data () {
      return {}
    },
    computed: {
      ...mapGetters(['isError', 'isMessage'])
    },
    components: {
      alert: Alert,
      navigation: Nav
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/jury/Jury.vue